module.exports = __webpack_public_path__ + "img/Phi-Kappa-t-24592-019.85ef6ae5.jpg";